import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 19F3DC9F-4861-4220-944C-8BE8D543902B
 * name square-off
 * version: 4.8.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/square-off.svg
 * tags
 */
export const SquareOffIcon = createSvgIcon(<><path d="M20.84 22.73L19.11 21H3V4.89L1.11 3L2.39 1.73L22.11 21.46L20.84 22.73M21 3H6.2L21 17.8V3Z" /></>, 'SquareOffIcon');
export default SquareOffIcon